var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoRecordsFoundInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 356.216,
    height: 339.334,
    viewBox: "0 0 356.216 339.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13118",
    "data-name": "Group 13118",
    transform: "translate(1650.812 -2887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND",
    transform: "translate(-1650.812 2887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13084",
    "data-name": "Group 13084",
    transform: "translate(6.188 5.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13079",
    "data-name": "Group 13079",
    transform: "translate(13.251 21.419)",
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5375",
    "data-name": "Path 5375",
    d: "M381.79,244.45a100.5,100.5,0,0,0-.458-17.147c-3.025-26.717-16.736-51.915-36.908-69.69-7.2-6.344-15.387-12.021-20.071-20.4-7.887-14.1-7.29-30.3-17.077-44.221a82.815,82.815,0,0,0-40.189-30.386c-48.029-16.643-115.261,10.454-109.212,68.318.023.209.047.512.07.892a21.067,21.067,0,0,1-20.637,22.413c-44.315,1.055-82.456,35.217-90.614,78.493-5.25,27.834,3.343,58.336,23.7,78.02,15.193,14.7,35.582,22.77,55.986,28.315,40.9,11.121,83.945,13.456,126.119,9.2,39.475-3.979,81.114-15.332,106.645-45.7,13.619-16.2,21.421-36.978,22.646-58.119Z",
    transform: "translate(-45.186 -57.766)",
    fill: "rgba(33,130,127,0.04)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13080",
    "data-name": "Group 13080",
    transform: "translate(135.085)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 10.307,
    cy: 10.307,
    r: 10.307,
    transform: "translate(0 20.35) rotate(-80.82)",
    fill: "#e1e2fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13081",
    "data-name": "Group 13081",
    transform: "translate(280.886 0.211)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 5.32,
    cy: 5.32,
    r: 5.32,
    fill: "#e1e2fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13082",
    "data-name": "Group 13082",
    transform: "translate(89.785 26.247)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 7.127,
    cy: 7.127,
    r: 7.127,
    transform: "translate(0 13.831) rotate(-76)",
    fill: "#e1e2fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13083",
    "data-name": "Group 13083",
    transform: "translate(0 277.181)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 16.232,
    cy: 16.232,
    r: 16.232,
    fill: "#e1e2fe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13087",
    "data-name": "Group 13087",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13085",
    "data-name": "Group 13085",
    transform: "translate(13.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5376",
    "data-name": "Path 5376",
    d: "M461.982,73.954a18.337,18.337,0,0,0-7.942-24.693c-9.012-4.63-26.33-4.289-30.96,4.723s9.245,16.744,14.9,25.151c7.887,11.718,19.373,3.831,24-5.181Z",
    transform: "translate(-123.96 -27.866)",
    fill: "#ecf1f7",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5377",
    "data-name": "Path 5377",
    d: "M420.565,430.66a14.049,14.049,0,0,0,19.427-4.188c4.211-6.522,5.258-19.745-1.256-23.957s-13.463,5.778-20.3,9.454C408.9,417.1,414.042,426.449,420.565,430.66Z",
    transform: "translate(-121.948 -107.587)",
    fill: "rgba(33,130,127,0.34)",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5378",
    "data-name": "Path 5378",
    d: "M70.139,27.259a17.722,17.722,0,0,0-25.042.923c-6.662,7.174-10.873,23.367-3.7,30.029s17.993-4.219,27.291-7.282c12.967-4.273,8.632-17.015,1.458-23.677Z",
    transform: "translate(-37.658 -22.523)",
    fill: "rgba(33,130,127,0.27)",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13086",
    "data-name": "Group 13086",
    transform: "translate(0 26.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5379",
    "data-name": "Path 5379",
    d: "M26.666,112.4a73.071,73.071,0,0,0-5.072,44.842c3.606,17.589,14.557,31.1,10.757,49.86-2.311,11.432-2.893,22.018-4.064,33.325-2.412,23.22,12.665,43.679,31.371,54.73,15.193,8.973,33,12.339,50.465,12.1,15.72-.217,31.409-3.118,46.641-7.019,14.681-3.761,29.029-8.717,44.415-7.151,12.8,1.3,24.321,6.833,36.241,10.958,28.455,9.849,62.912,11.238,88.932-3.754a75.077,75.077,0,0,0,35.132-81.742c-3.187-14.076-8.57-28.261-6.9-42.926,1.163-10.222,5.84-20.079,4.979-30.331-.566-6.809-3.568-13.2-7.236-18.962-13.386-21.056-35.807-35.155-59.515-42.919-22.312-7.313-45.331-12.6-68.558-10.842-48.037,3.637-57.824-3.994-106.916-14.495C85.646,51.3,50.2,75.464,31.653,103.454a66.406,66.406,0,0,0-4.979,8.95Z",
    transform: "translate(-20.121 -56.925)",
    fill: "rgba(33,130,127,0.13)",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5380",
    "data-name": "Path 5380",
    d: "M64.24,138.175c-.985,11.083,2.753,22.506-.372,33.48C60.129,184.8,49.3,194.642,44.882,207.547,38.36,226.61,38.67,247.976,46.6,266.558c3.816,8.957,9.392,17.271,17.008,23.026,11.742,8.872,27.121,10.819,41.592,9.694,21.529-1.675,44.252-11,65.9-8.453,11.943,1.4,15.6,14.332,21.762,22.863a71.451,71.451,0,0,0,26.989,22.266c19.35,9.291,42.577,10.167,62.354,1.745,21.118-9,39.522-30.952,38.312-55.793-.558-11.494-5.157-22.9-3.032-34.194,2.676-14.169,13.347-27.082,21.087-38.622a88.965,88.965,0,0,0,14.728-43.461c.008-.178.023-.349.031-.527a59.191,59.191,0,0,0-40.755-59.538L258.389,87.741c-54.978-18.078-109.9-17.481-160.452,9.051C87,102.531,69.188,119.639,65.519,131.435a32.326,32.326,0,0,0-1.287,6.732Z",
    transform: "translate(-24.649 -61.058)",
    fill: "rgba(33,130,127,0.07)",
    opacity: 0.81
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 3.49,
    cy: 3.49,
    r: 3.49,
    transform: "translate(343.588 274.974)",
    fill: "#21827f",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 3.49,
    cy: 3.49,
    r: 3.49,
    transform: "translate(182.368 2.976)",
    fill: "#21827f",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 3.49,
    cy: 3.49,
    r: 3.49,
    transform: "translate(56.296 307.159)",
    fill: "#21827f",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 2.714,
    cy: 2.714,
    r: 2.714,
    transform: "translate(277.349 322.608)",
    fill: "#ed4c16",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 1.163,
    cy: 1.163,
    r: 1.163,
    transform: "translate(43.212 64.74)",
    fill: "#21827f",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5381",
    "data-name": "Path 5381",
    d: "M394.461,61.294a4.191,4.191,0,1,1-3.226-4.971A4.19,4.19,0,0,1,394.461,61.294Z",
    transform: "translate(-102.284 -30.089)",
    fill: "#ed4c16",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5382",
    "data-name": "Path 5382",
    d: "M107.128,37.344a1.646,1.646,0,1,1-1.264-1.954A1.649,1.649,0,0,1,107.128,37.344Z",
    transform: "translate(-38.92 -25.403)",
    fill: "#ed4c16",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5383",
    "data-name": "Path 5383",
    d: "M445.029,28.531a1.4,1.4,0,1,1-1.078-1.66A1.406,1.406,0,0,1,445.029,28.531Z",
    transform: "translate(-114.874 -23.493)",
    fill: "#3e479b",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5384",
    "data-name": "Path 5384",
    d: "M63.979,458.151a1.4,1.4,0,1,1-1.078-1.66A1.406,1.406,0,0,1,63.979,458.151Z",
    transform: "translate(-29.344 -119.924)",
    fill: "#21827f",
    opacity: 0.58
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13097",
    "data-name": "Group 13097",
    transform: "translate(-1630.99 2976.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13089",
    "data-name": "Group 13089",
    transform: "translate(32.626 0)",
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13088",
    "data-name": "Group 13088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5385",
    "data-name": "Path 5385",
    d: "M170.918,178.053l-6.173-.473a31.786,31.786,0,0,0-4.227-12.905l4.7-4.033a5.676,5.676,0,1,0-7.391-8.616l-4.7,4.033a31.769,31.769,0,0,0-12.114-6.135l.473-6.173a5.68,5.68,0,0,0-5.227-6.1h0a5.68,5.68,0,0,0-6.1,5.227l-.473,6.173a31.786,31.786,0,0,0-12.905,4.227l-4.033-4.7a5.676,5.676,0,1,0-8.616,7.391l4.033,4.7a31.768,31.768,0,0,0-6.135,12.114l-6.173-.473a5.68,5.68,0,0,0-6.1,5.227h0a5.68,5.68,0,0,0,5.227,6.1l6.173.473a31.786,31.786,0,0,0,4.227,12.905l-4.7,4.033a5.676,5.676,0,1,0,7.391,8.616l4.7-4.033a31.769,31.769,0,0,0,12.114,6.135l-.473,6.173a5.68,5.68,0,0,0,5.227,6.1h0a5.68,5.68,0,0,0,6.1-5.227l.473-6.173a31.786,31.786,0,0,0,12.905-4.227l4.033,4.7a5.676,5.676,0,0,0,8.616-7.391l-4.033-4.7a31.769,31.769,0,0,0,6.135-12.114l6.173.473a5.68,5.68,0,0,0,6.1-5.227h0a5.68,5.68,0,0,0-5.227-6.1ZM131.2,203.91a23.128,23.128,0,1,1,24.825-21.3,23.121,23.121,0,0,1-24.825,21.3Z",
    transform: "translate(-89.748 -137.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5386",
    "data-name": "Path 5386",
    d: "M353.56,396.968a4.735,4.735,0,0,1-4.5-3.3l-1.109-3.5a22.687,22.687,0,0,1-8.484-.729l-1.691,3.257a4.736,4.736,0,0,1-6.375,2.016,4.732,4.732,0,0,1-2.016-6.375l1.691-3.257a22.717,22.717,0,0,1-5.483-6.515l-3.5,1.109a4.729,4.729,0,0,1-5.63-6.685,4.68,4.68,0,0,1,2.769-2.327l3.5-1.109a22.7,22.7,0,0,1,.729-8.484l-3.257-1.691a4.728,4.728,0,0,1,4.359-8.391l3.257,1.691a22.614,22.614,0,0,1,6.515-5.483l-1.109-3.5a4.73,4.73,0,0,1,6.685-5.63,4.68,4.68,0,0,1,2.327,2.769l1.109,3.5a22.69,22.69,0,0,1,8.484.729l1.691-3.257a4.728,4.728,0,0,1,8.391,4.359l-1.691,3.257a22.717,22.717,0,0,1,5.483,6.515l3.5-1.109a4.73,4.73,0,0,1,2.854,9.02l-3.5,1.109a22.7,22.7,0,0,1-.729,8.484l3.257,1.691A4.736,4.736,0,0,1,373.1,381.5a4.731,4.731,0,0,1-6.375,2.016l-3.257-1.691a22.82,22.82,0,0,1-6.515,5.483l1.109,3.5a4.723,4.723,0,0,1-3.079,5.933,4.817,4.817,0,0,1-1.435.225Zm-4.521-8.5,1.5,4.731a3.181,3.181,0,0,0,6.065-1.923l-1.5-4.731.574-.3a21.2,21.2,0,0,0,6.988-5.879l.4-.512,4.405,2.288a3.181,3.181,0,1,0,2.932-5.646l-4.405-2.288.194-.62a21.125,21.125,0,0,0,.783-9.1l-.085-.644,4.731-1.5a3.18,3.18,0,0,0-1.916-6.065l-4.731,1.5-.3-.574a21.2,21.2,0,0,0-5.879-6.988l-.512-.4,2.288-4.405a3.181,3.181,0,1,0-5.646-2.932l-2.288,4.405-.62-.194a21.245,21.245,0,0,0-9.1-.783l-.644.085-1.5-4.731a3.181,3.181,0,0,0-6.065,1.923l1.5,4.731-.574.3a21.2,21.2,0,0,0-6.988,5.879l-.4.512-4.405-2.288a3.176,3.176,0,1,0-2.924,5.638l4.405,2.288-.194.62a21.125,21.125,0,0,0-.783,9.1l.085.644-4.731,1.5a3.181,3.181,0,0,0,1.923,6.065l4.731-1.5.3.574a21.2,21.2,0,0,0,5.879,6.988l.512.4-2.288,4.405a3.179,3.179,0,0,0,5.646,2.924l2.288-4.405.62.194a21.22,21.22,0,0,0,9.089.783l.644-.085Zm-3.4-4.328a16.775,16.775,0,1,0-.008,0Zm.039-32.239a15.44,15.44,0,0,0-4.645.721,15.267,15.267,0,1,0,4.645-.721Z",
    transform: "translate(-140.517 -182.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5387",
    "data-name": "Path 5387",
    d: "M406.573,353.13a6.747,6.747,0,0,1-.876-.062,6.09,6.09,0,0,1-5.15-6.9l.745-5.1a30.314,30.314,0,0,1-10.113-6.018l-4.134,3.079a6.087,6.087,0,1,1-7.282-9.756l4.134-3.079A30.333,30.333,0,0,1,381,313.88l-5.1-.745a6.093,6.093,0,0,1,1.753-12.06l5.1.745a30.313,30.313,0,0,1,6.018-10.113l-3.079-4.126a6.1,6.1,0,0,1,5.762-9.679,6,6,0,0,1,4,2.389l3.079,4.126a30.333,30.333,0,0,1,11.408-2.893l.745-5.1a6.094,6.094,0,0,1,6.9-5.15,6.089,6.089,0,0,1,5.15,6.9l-.745,5.1a30.314,30.314,0,0,1,10.113,6.018l4.134-3.079a6.09,6.09,0,0,1,7.282,9.764l-4.126,3.079a30.333,30.333,0,0,1,2.893,11.408l5.1.745a6.089,6.089,0,1,1-1.753,12.052l-5.1-.737a30.313,30.313,0,0,1-6.018,10.113l3.079,4.134a6.094,6.094,0,0,1-5.762,9.671,6.036,6.036,0,0,1-4.01-2.389l-3.079-4.126a30.333,30.333,0,0,1-11.408,2.893l-.745,5.1a6.115,6.115,0,0,1-6.026,5.219Zm-15.3-20.1.473.442a28.871,28.871,0,0,0,10.64,6.336l.613.2-.923,6.375a4.537,4.537,0,1,0,8.981,1.3l.923-6.375.651-.023a28.683,28.683,0,0,0,12-3.048l.582-.287,3.854,5.165a4.541,4.541,0,0,0,6.352.923,4.541,4.541,0,0,0,.923-6.352l-3.854-5.165.442-.473a28.809,28.809,0,0,0,6.336-10.64l.2-.613,6.375.923a4.537,4.537,0,1,0,1.3-8.981l-6.375-.923-.023-.651a28.682,28.682,0,0,0-3.048-12l-.287-.582,5.165-3.854a4.54,4.54,0,0,0,.923-6.352,4.541,4.541,0,0,0-6.352-.923h0l-5.165,3.854-.473-.442a28.87,28.87,0,0,0-10.64-6.336l-.613-.2.923-6.375a4.537,4.537,0,0,0-8.981-1.3l-.923,6.375-.651.023a28.683,28.683,0,0,0-12,3.048l-.582.287-3.854-5.165a4.538,4.538,0,0,0-7.275,5.429l3.854,5.165-.442.473a28.87,28.87,0,0,0-6.336,10.64l-.2.613-6.375-.923a4.542,4.542,0,0,0-3.366.853,4.49,4.49,0,0,0-1.776,2.986,4.546,4.546,0,0,0,3.839,5.142l6.375.923.023.651a28.683,28.683,0,0,0,3.048,12l.287.582-5.165,3.854a4.538,4.538,0,0,0,5.429,7.275Zm20.389,1.559a22.42,22.42,0,1,1,13.386-4.452h0a22.3,22.3,0,0,1-13.386,4.444Zm-.07-43.3A20.881,20.881,0,1,0,424.132,328.9h0a20.877,20.877,0,0,0-9.485-37.389,21.216,21.216,0,0,0-3.048-.225Zm13,38.234Z",
    transform: "translate(-152.807 -167.618)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13096",
    "data-name": "Group 13096",
    transform: "translate(0 100.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13092",
    "data-name": "Group 13092",
    transform: "translate(97.649 66.619)",
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5388",
    "data-name": "Path 5388",
    d: "M282.825,380.411H266.9a.776.776,0,0,1,0-1.551h15.93a.776.776,0,0,1,0,1.551Z",
    transform: "translate(-194.359 -358.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5389",
    "data-name": "Path 5389",
    d: "M282.825,401.771H266.9a.776.776,0,1,1,0-1.551h15.93a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-194.359 -363.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13091",
    "data-name": "Group 13091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13090",
    "data-name": "Group 13090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5390",
    "data-name": "Path 5390",
    d: "M274.085,407.783H175.692a2.1,2.1,0,0,1-2.1-2.1v-51.07a2.1,2.1,0,0,1,2.1-2.1h98.393a2.1,2.1,0,0,1,2.1,2.1v51.07A2.1,2.1,0,0,1,274.085,407.783Zm-98.393-53.722a.553.553,0,0,0-.551.551v51.07a.553.553,0,0,0,.551.551h98.393a.553.553,0,0,0,.551-.551v-51.07a.553.553,0,0,0-.551-.551Z",
    transform: "translate(-173.59 -352.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5391",
    "data-name": "Path 5391",
    d: "M274.085,407.783H175.692a2.1,2.1,0,0,1-2.1-2.1v-51.07a2.1,2.1,0,0,1,2.1-2.1h98.393a2.1,2.1,0,0,1,2.1,2.1v51.07A2.1,2.1,0,0,1,274.085,407.783Zm-98.393-53.722a.553.553,0,0,0-.551.551v51.07a.553.553,0,0,0,.551.551h98.393a.553.553,0,0,0,.551-.551v-51.07a.553.553,0,0,0-.551-.551Z",
    transform: "translate(-173.59 -352.51)",
    fill: "#fff",
    opacity: 0.66
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5392",
    "data-name": "Path 5392",
    d: "M265.463,370.051H189.546a.776.776,0,1,1,0-1.551h75.918a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-176.997 -356.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5393",
    "data-name": "Path 5393",
    d: "M265.463,390.781H189.546a.776.776,0,0,1,0-1.551h75.918a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-176.997 -360.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5394",
    "data-name": "Path 5394",
    d: "M230.479,380.411H189.546a.776.776,0,1,1,0-1.551h40.933a.776.776,0,0,1,0,1.551Z",
    transform: "translate(-176.997 -358.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5395",
    "data-name": "Path 5395",
    d: "M230.479,401.771H189.546a.776.776,0,1,1,0-1.551h40.933a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-176.997 -363.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5396",
    "data-name": "Path 5396",
    d: "M217.147,411.661h-27.6a.776.776,0,1,1,0-1.551h27.6a.776.776,0,0,1,0,1.551Z",
    transform: "translate(-176.997 -365.439)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13095",
    "data-name": "Group 13095",
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5397",
    "data-name": "Path 5397",
    d: "M85.713,316.391H67.806a.776.776,0,1,1,0-1.551H85.713a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-52.023 -277.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5398",
    "data-name": "Path 5398",
    d: "M85.713,292.391H67.806a.776.776,0,1,1,0-1.551H85.713a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-52.023 -272.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13094",
    "data-name": "Group 13094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13093",
    "data-name": "Group 13093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5399",
    "data-name": "Path 5399",
    d: "M160.7,328.537H49.782a2.1,2.1,0,0,1-2.1-2.1V268.712a2.1,2.1,0,0,1,2.1-2.1H160.7a2.1,2.1,0,0,1,2.1,2.1v57.724A2.1,2.1,0,0,1,160.7,328.537ZM49.782,268.153a.553.553,0,0,0-.551.551v57.724a.553.553,0,0,0,.551.551H160.7a.553.553,0,0,0,.551-.551V268.7a.553.553,0,0,0-.551-.551Z",
    transform: "translate(-47.68 -266.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5400",
    "data-name": "Path 5400",
    d: "M160.7,328.537H49.782a2.1,2.1,0,0,1-2.1-2.1V268.712a2.1,2.1,0,0,1,2.1-2.1H160.7a2.1,2.1,0,0,1,2.1,2.1v57.724A2.1,2.1,0,0,1,160.7,328.537ZM49.782,268.153a.553.553,0,0,0-.551.551v57.724a.553.553,0,0,0,.551.551H160.7a.553.553,0,0,0,.551-.551V268.7a.553.553,0,0,0-.551-.551Z",
    transform: "translate(-47.68 -266.61)",
    fill: "#fff",
    opacity: 0.66
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5401",
    "data-name": "Path 5401",
    d: "M153.131,328.031H67.806a.776.776,0,1,1,0-1.551h85.325a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-52.023 -280.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5402",
    "data-name": "Path 5402",
    d: "M153.131,304.741H67.806a.776.776,0,0,1,0-1.551h85.325a.776.776,0,0,1,0,1.551Z",
    transform: "translate(-52.023 -274.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5403",
    "data-name": "Path 5403",
    d: "M164.511,316.391H118.506a.776.776,0,1,1,0-1.551h46.005a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-63.403 -277.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5404",
    "data-name": "Path 5404",
    d: "M164.511,292.391H118.506a.776.776,0,1,1,0-1.551h46.005a.776.776,0,0,1,0,1.551Z",
    transform: "translate(-63.403 -272.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5405",
    "data-name": "Path 5405",
    d: "M168.847,281.271H137.826a.776.776,0,1,1,0-1.551h31.022a.776.776,0,0,1,0,1.551Z",
    transform: "translate(-67.74 -269.553)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13106",
    "data-name": "Group 13106",
    transform: "translate(-1477.087 2941.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13098",
    "data-name": "Group 13098",
    transform: "translate(0 54.671)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2239",
    "data-name": "Rectangle 2239",
    width: 137.194,
    height: 101.526,
    rx: 1.85,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, 2.198, 122.646)",
    fill: "#3e479b",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2240",
    "data-name": "Rectangle 2240",
    width: 137.194,
    height: 101.526,
    rx: 1.85,
    transform: "matrix(0.51, -0.86, 0.86, 0.51, 0, 118.015)",
    fill: "#ed4c16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13101",
    "data-name": "Group 13101",
    transform: "translate(9.962 63.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5406",
    "data-name": "Path 5406",
    d: "M360.149,334.836l-97.02-17.884a1.442,1.442,0,0,1-1.156-1.675l24.352-132.1A1.442,1.442,0,0,1,288,182.023l97.02,17.884a1.442,1.442,0,0,1,1.156,1.675l-24.352,132.1A1.442,1.442,0,0,1,360.149,334.836Z",
    transform: "translate(-259.639 -175.871)",
    fill: "#3e479b",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2241",
    "data-name": "Rectangle 2241",
    width: 137.194,
    height: 101.526,
    transform: "translate(0 137.098) rotate(-79.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2242",
    "data-name": "Rectangle 2242",
    width: 137.194,
    height: 101.526,
    rx: 1.85,
    transform: "translate(0 137.098) rotate(-79.56)",
    fill: "#ed4c16",
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5407",
    "data-name": "Path 5407",
    d: "M393.059,219.4a.43.43,0,0,1-.14-.016l-24.282-4.475a.773.773,0,1,1,.287-1.52l24.282,4.475a.774.774,0,0,1-.14,1.536Z",
    transform: "translate(-283.444 -182.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5408",
    "data-name": "Path 5408",
    d: "M391.209,229.4a.429.429,0,0,1-.14-.016l-24.282-4.475a.773.773,0,1,1,.279-1.52l24.282,4.475a.774.774,0,0,1-.14,1.536Z",
    transform: "translate(-283.028 -185.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5409",
    "data-name": "Path 5409",
    d: "M389.209,240.277a.429.429,0,0,1-.14-.016l-24.282-4.475a.773.773,0,1,1,.279-1.52l24.282,4.475a.774.774,0,0,1-.14,1.536Z",
    transform: "translate(-282.579 -187.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13099",
    "data-name": "Group 13099",
    transform: "translate(25.904)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2243",
    "data-name": "Rectangle 2243",
    width: 48.611,
    height: 45.416,
    rx: 2,
    transform: "translate(0 51.874) rotate(-79.56)",
    fill: "#3e479b",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2244",
    "data-name": "Rectangle 2244",
    width: 46.191,
    height: 43.446,
    rx: 2,
    transform: "translate(0.407 49.643) rotate(-79.56)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5410",
    "data-name": "Path 5410",
    d: "M345.125,193.025,302.4,185.153l.745-4.041a1.5,1.5,0,0,1,1.76-1.21l39.809,7.337a1.451,1.451,0,0,1,1.163,1.691l-.752,4.095Z",
    transform: "translate(-294.622 -175.394)",
    fill: "#ecf1f7",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5411",
    "data-name": "Path 5411",
    d: "M316.012,204.927a5.287,5.287,0,0,1-.915-.085l-.589-.109a5.8,5.8,0,0,1-4.645-6.747l1.489-8.1a1.164,1.164,0,0,1,2.288.427l-1.489,8.1a3.474,3.474,0,0,0,2.776,4.041l.589.109a2.7,2.7,0,0,0,3.141-2.164l3.777-20.49a2.787,2.787,0,0,0-2.234-3.242l-1.008-.186a2.963,2.963,0,0,0-3.443,2.365l-.093.5a1.164,1.164,0,0,1-2.288-.427l.093-.5a5.288,5.288,0,0,1,6.15-4.234l1.008.186a5.112,5.112,0,0,1,4.095,5.948l-3.777,20.49a5.028,5.028,0,0,1-4.94,4.11Z",
    transform: "translate(-296.275 -174.097)",
    fill: "#3e479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5412",
    "data-name": "Path 5412",
    d: "M318.421,190.612h-.07l-15.5-2.854a.387.387,0,0,1-.31-.45.381.381,0,0,1,.45-.31l15.5,2.854a.387.387,0,0,1-.07.768Z",
    transform: "translate(-294.652 -176.99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13100",
    "data-name": "Group 13100",
    transform: "translate(16.793 66.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5413",
    "data-name": "Path 5413",
    d: "M362.44,290.592a.43.43,0,0,1-.14-.016L288.1,276.9a.773.773,0,0,1,.279-1.52l74.2,13.681a.774.774,0,0,1-.14,1.536Z",
    transform: "translate(-282.159 -263.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5414",
    "data-name": "Path 5414",
    d: "M355.6,327.7a.43.43,0,0,1-.14-.016L281.257,314a.778.778,0,0,1-.62-.907.768.768,0,0,1,.9-.62l74.2,13.681a.778.778,0,0,1-.14,1.543Z",
    transform: "translate(-280.623 -271.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5415",
    "data-name": "Path 5415",
    d: "M319.894,301.929a.429.429,0,0,1-.14-.016l-35.078-6.468a.773.773,0,0,1,.279-1.52l35.078,6.468a.778.778,0,0,1-.14,1.543Z",
    transform: "translate(-281.391 -267.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5416",
    "data-name": "Path 5416",
    d: "M326.124,268.12a.43.43,0,0,1-.14-.016l-35.078-6.468a.773.773,0,0,1,.279-1.52l35.078,6.468a.778.778,0,0,1-.14,1.543Z",
    transform: "translate(-282.789 -260.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5417",
    "data-name": "Path 5417",
    d: "M370.852,311.177a.43.43,0,0,1-.14-.016L337.287,305a.777.777,0,0,1,.287-1.528L371,309.634a.778.778,0,0,1-.14,1.543Z",
    transform: "translate(-293.2 -269.836)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13105",
    "data-name": "Group 13105",
    transform: "translate(52.725 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    d: "M2.583,0H43.834a2.583,2.583,0,0,1,2.583,2.583v13.8a2.583,2.583,0,0,1-2.583,2.583H2.583A2.583,2.583,0,0,1,0,16.379V2.583A2.583,2.583,0,0,1,2.583,0Z",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2246",
    "data-name": "Rectangle 2246",
    width: 62.858,
    height: 25.686,
    rx: 3.33,
    transform: "translate(14.619 13.952)",
    fill: "rgba(237,76,22,0.49)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13104",
    "data-name": "Group 13104",
    transform: "translate(26.469 34.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13102",
    "data-name": "Group 13102"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2247",
    "data-name": "Rectangle 2247",
    width: 70.9,
    height: 26.586,
    rx: 4.52,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2248",
    "data-name": "Rectangle 2248",
    width: 70.9,
    height: 26.586,
    rx: 4.52,
    fill: "#21827f",
    opacity: 0.74
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13103",
    "data-name": "Group 13103",
    transform: "translate(20.769 10.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5418",
    "data-name": "Path 5418",
    d: "M409.759,155.878a3.079,3.079,0,1,1,3.079-3.079A3.081,3.081,0,0,1,409.759,155.878Zm0-5.382a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,409.759,150.5Z",
    transform: "translate(-382.126 -149.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5419",
    "data-name": "Path 5419",
    d: "M393.369,155.878a3.079,3.079,0,1,1,3.079-3.079A3.081,3.081,0,0,1,393.369,155.878Zm0-5.382a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,393.369,150.5Z",
    transform: "translate(-378.447 -149.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5420",
    "data-name": "Path 5420",
    d: "M378.1,155.878a3.079,3.079,0,1,1,3.079-3.079A3.081,3.081,0,0,1,378.1,155.878Zm0-5.382a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,378.1,150.5Z",
    transform: "translate(-375.02 -149.72)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13109",
    "data-name": "Group 13109",
    transform: "translate(-1554.924 2943.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5421",
    "data-name": "Path 5421",
    d: "M150.9,94.8h98.99a3.613,3.613,0,0,1,3.614,3.614v145.8a12.455,12.455,0,0,1-12.455,12.455H172.309A26.538,26.538,0,0,1,145.77,230.13V99.916A5.127,5.127,0,0,1,150.9,94.79Z",
    transform: "translate(-145.762 -94.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5422",
    "data-name": "Path 5422",
    d: "M147.024,94.8H251.552a1.94,1.94,0,0,1,1.939,1.939V244.8a11.869,11.869,0,0,1-11.874,11.874H169.941A24.182,24.182,0,0,1,145.76,232.49V96.056a1.256,1.256,0,0,1,1.256-1.256Z",
    transform: "translate(-145.76 -94.792)",
    fill: "#21827f",
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5423",
    "data-name": "Path 5423",
    d: "M158.961,94.8h95.772a1.526,1.526,0,0,1,1.528,1.528V245.2a11.469,11.469,0,0,1-11.47,11.47H181.878A23.776,23.776,0,0,1,158.1,232.893V95.653a.851.851,0,0,1,.853-.853Z",
    transform: "translate(-148.53 -94.792)",
    fill: "#21827f",
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5424",
    "data-name": "Path 5424",
    d: "M177.49,296.288v.031h86.527a18.032,18.032,0,0,0,18.031-18.031V271.44h-87.5v6.848A18.034,18.034,0,0,1,177.49,296.3Z",
    transform: "translate(-152.882 -134.44)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13107",
    "data-name": "Group 13107",
    transform: "translate(36.078 137)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5425",
    "data-name": "Path 5425",
    d: "M192.28,296.288v.031h77.035c8.864,0,16.054-8.073,16.054-18.031V271.44h-77.9v6.848c0,9.632-6.724,17.5-15.185,18.008Z",
    transform: "translate(-192.28 -271.44)",
    fill: "#35bbb7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13108",
    "data-name": "Group 13108",
    transform: "translate(26.446 25.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5426",
    "data-name": "Path 5426",
    d: "M245.36,246.921H183.146a.776.776,0,0,1,0-1.551H245.36a.776.776,0,0,1,0,1.551Z",
    transform: "translate(-180.423 -153.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5427",
    "data-name": "Path 5427",
    d: "M246.326,213.151h-64.68a.776.776,0,1,1,0-1.551h64.68a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-180.087 -146.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5428",
    "data-name": "Path 5428",
    d: "M213.689,230.021H180.636a.776.776,0,0,1,0-1.551h33.054a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-179.86 -150.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5429",
    "data-name": "Path 5429",
    d: "M211.909,230.021H183.866a.776.776,0,1,1,0-1.551h28.044a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-180.585 -150.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5430",
    "data-name": "Path 5430",
    d: "M224.8,177.031H182.226a.776.776,0,1,1,0-1.551H224.8a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-180.217 -138.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5431",
    "data-name": "Path 5431",
    d: "M258.823,177.031H245.856a.776.776,0,1,1,0-1.551h12.967a.776.776,0,0,1,0,1.551Z",
    transform: "translate(-194.499 -138.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5432",
    "data-name": "Path 5432",
    d: "M251.7,193.911H205.6a.776.776,0,0,1,0-1.551H251.7a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-185.462 -141.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5433",
    "data-name": "Path 5433",
    d: "M195.667,193.911H181.646a.776.776,0,0,1,0-1.551h14.022a.776.776,0,0,1,0,1.551Z",
    transform: "translate(-180.087 -141.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5434",
    "data-name": "Path 5434",
    d: "M245.36,162.751H183.146a.776.776,0,1,1,0-1.551H245.36a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-180.423 -135.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5435",
    "data-name": "Path 5435",
    d: "M245.36,128.971H183.146a.776.776,0,1,1,0-1.551H245.36a.776.776,0,1,1,0,1.551Z",
    transform: "translate(-180.423 -127.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5436",
    "data-name": "Path 5436",
    d: "M205.771,145.841H182.226a.776.776,0,1,1,0-1.551h23.545a.776.776,0,0,1,0,1.551Z",
    transform: "translate(-180.217 -131.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5437",
    "data-name": "Path 5437",
    d: "M254.639,145.841H226.6a.776.776,0,0,1,0-1.551h28.044a.776.776,0,0,1,0,1.551Z",
    transform: "translate(-190.176 -131.207)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13113",
    "data-name": "Group 13113",
    transform: "translate(-1484.479 2969.495)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 49.084,
    cy: 49.084,
    r: 49.084,
    transform: "translate(0 69.416) rotate(-45)",
    fill: "#fff",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5438",
    "data-name": "Path 5438",
    d: "M275.6,209.046a3.1,3.1,0,0,1-3.1-3.1,44.956,44.956,0,0,1,44.9-44.9,3.1,3.1,0,0,1,0,6.2,38.743,38.743,0,0,0-38.7,38.7A3.1,3.1,0,0,1,275.6,209.046Z",
    transform: "translate(-244.653 -136.109)",
    fill: "#fff",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5439",
    "data-name": "Path 5439",
    d: "M311.445,254.38a50.635,50.635,0,1,1,50.635-50.635A50.694,50.694,0,0,1,311.445,254.38Zm0-98.168a47.533,47.533,0,1,0,47.533,47.533,47.587,47.587,0,0,0-47.533-47.533Z",
    transform: "translate(-242.029 -134.329)",
    fill: "#3e479b",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13112",
    "data-name": "Group 13112",
    transform: "translate(11.359 11.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13111",
    "data-name": "Group 13111"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 49.084,
    cy: 49.084,
    r: 49.084,
    transform: "translate(8.973 8.973)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13110",
    "data-name": "Group 13110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5440",
    "data-name": "Path 5440",
    d: "M354.633,236.982a2.8,2.8,0,0,1,.233-.194,57.453,57.453,0,1,0-10.5,10.454l6.623-6.623,3.637-3.637ZM309.519,250.9A49.084,49.084,0,1,1,358.6,201.812,49.083,49.083,0,0,1,309.519,250.9Z",
    transform: "translate(-251.462 -143.754)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5441",
    "data-name": "Path 5441",
    d: "M309.3,259.644a58.057,58.057,0,1,1,58.057-58.057,57.483,57.483,0,0,1-12.091,35.45l-.147.147a1.067,1.067,0,0,0-.147.116l-10.338,10.33A57.483,57.483,0,0,1,309.3,259.637Zm0-114.563a56.506,56.506,0,0,0,0,113.012,55.974,55.974,0,0,0,34.341-11.656l10.229-10.229a1.4,1.4,0,0,1,.233-.194,55.986,55.986,0,0,0,11.7-34.426A56.57,56.57,0,0,0,309.3,145.081Zm0,106.366a49.86,49.86,0,1,1,49.86-49.86A49.916,49.916,0,0,1,309.3,251.447Zm0-98.168a48.309,48.309,0,1,0,48.309,48.309A48.36,48.36,0,0,0,309.3,153.279Z",
    transform: "translate(-251.24 -143.53)",
    fill: "#21827f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5442",
    "data-name": "Path 5442",
    d: "M379.665,273.753l-2.218-2.218a2.191,2.191,0,0,1,0-3.094l-6.623,6.623-.109.109a2.191,2.191,0,0,0,0,3.094l2.7,2.7a53.357,53.357,0,0,1,6.259-7.213Z",
    transform: "translate(-277.913 -171.567)",
    fill: "#156563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5443",
    "data-name": "Path 5443",
    d: "M379.395,267.191a2.191,2.191,0,0,0,0,3.094l2.218,2.218a61.778,61.778,0,0,1,7.1-6.375l-2.583-2.583a2.188,2.188,0,0,0-2.862-.194,1.815,1.815,0,0,0-.233.194l-3.637,3.637Z",
    transform: "translate(-279.862 -170.326)",
    fill: "#4c65ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5444",
    "data-name": "Path 5444",
    d: "M379.395,267.191a2.191,2.191,0,0,0,0,3.094l2.218,2.218a61.778,61.778,0,0,1,7.1-6.375l-2.583-2.583a2.188,2.188,0,0,0-2.862-.194,1.815,1.815,0,0,0-.233.194l-3.637,3.637Z",
    transform: "translate(-279.862 -170.326)",
    fill: "#637776",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5445",
    "data-name": "Path 5445",
    d: "M429.194,307.214l-40.336-40.778c-.147-.147-.589.047-1.218.481a61.036,61.036,0,0,0-7.1,6.375,52.408,52.408,0,0,0-6.259,7.213c-.287.489-.4.822-.271.946l40.336,40.778a10.416,10.416,0,0,0,14.852,0,10.7,10.7,0,0,0,0-15.014Z",
    transform: "translate(-278.785 -171.106)",
    fill: "#21827f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5446",
    "data-name": "Path 5446",
    d: "M430.827,307.214l-40.336-40.778c-.543-.551-5.142,3.568-9.089,7.639-3.358,3.459,45.323,52.295,49.425,48.153h0a10.7,10.7,0,0,0,0-15.014Z",
    transform: "translate(-280.419 -171.106)",
    fill: "#21827f",
    opacity: 0.14
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13115",
    "data-name": "Group 13115",
    transform: "translate(-1618.279 3038.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2249",
    "data-name": "Rectangle 2249",
    width: 160.646,
    height: 28.051,
    rx: 14.026,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5447",
    "data-name": "Path 5447",
    d: "M246.849,245.631H225.281l-.1-28.051h21.669a14.03,14.03,0,0,1,14.03,14.03h0a14.03,14.03,0,0,1-14.03,14.03Z",
    transform: "translate(-100.232 -217.58)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13114",
    "data-name": "Group 13114",
    transform: "translate(135.022 6.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5448",
    "data-name": "Path 5448",
    d: "M244.3,238.459a6.135,6.135,0,1,1,6.135-6.135,6.143,6.143,0,0,1-6.135,6.135Zm0-10.718a4.585,4.585,0,1,0,4.583,4.583A4.587,4.587,0,0,0,244.3,227.741Z",
    transform: "translate(-238.17 -226.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5449",
    "data-name": "Path 5449",
    d: "M255.575,244.433a.794.794,0,0,1-.551-.225l-4.87-4.87a.773.773,0,0,1,1.094-1.094l4.87,4.87a.772.772,0,0,1,0,1.094.762.762,0,0,1-.551.225Z",
    transform: "translate(-240.809 -228.845)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13117",
    "data-name": "Group 13117",
    transform: "translate(-1598.673 3073.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    d: "M220.358,284.685h-66a8.359,8.359,0,0,1-8.36-8.36v-5.483a8.392,8.392,0,0,0-8.391-8.391H107.121a8.392,8.392,0,0,0-8.391,8.391v87.117a7.815,7.815,0,0,0,7.817,7.817H220.358a7.815,7.815,0,0,0,7.817-7.817V292.5A7.815,7.815,0,0,0,220.358,284.685Z",
    transform: "translate(-91.455 -262.45)",
    fill: "#ed4c16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5451",
    "data-name": "Path 5451",
    d: "M210.978,284.685h-66a8.359,8.359,0,0,1-8.36-8.36v-5.483a8.392,8.392,0,0,0-8.391-8.391H97.741a8.392,8.392,0,0,0-8.391,8.391v87.117a7.815,7.815,0,0,0,7.817,7.817H210.986a7.815,7.815,0,0,0,7.817-7.817V292.5a7.815,7.815,0,0,0-7.817-7.817Z",
    transform: "translate(-89.35 -262.45)",
    fill: "#ed4c16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5452",
    "data-name": "Path 5452",
    d: "M210.978,284.685h-66a8.359,8.359,0,0,1-8.36-8.36v-5.483a8.392,8.392,0,0,0-8.391-8.391H97.741a8.392,8.392,0,0,0-8.391,8.391v87.117a7.815,7.815,0,0,0,7.817,7.817H210.986a7.815,7.815,0,0,0,7.817-7.817V292.5a7.815,7.815,0,0,0-7.817-7.817Z",
    transform: "translate(-89.35 -262.45)",
    fill: "#fff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5453",
    "data-name": "Path 5453",
    d: "M194.242,284.685H137.325c-3.986,0-7.213-3.746-7.213-8.36v-5.483c0-4.638-3.242-8.391-7.236-8.391H96.586c-3.994,0-7.236,3.761-7.236,8.391v87.117c0,4.32,3.017,7.817,6.739,7.817h98.153c3.723,0,6.739-3.5,6.739-7.817V292.5C200.982,288.182,197.965,284.685,194.242,284.685Z",
    transform: "translate(-89.35 -262.45)",
    fill: "#fff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5454",
    "data-name": "Path 5454",
    d: "M96.986,295.071a.778.778,0,0,1-.776-.776V275.263a5.349,5.349,0,0,1,5.343-5.344h22.46a.776.776,0,0,1,0,1.551h-22.46a3.793,3.793,0,0,0-3.792,3.792V294.3A.778.778,0,0,1,96.986,295.071Z",
    transform: "translate(-90.89 -264.127)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecordsFoundInfo);
export default __webpack_public_path__ + "static/media/no-records-found-info.c973319822fa2d5896c4b3190c45340e.svg";
export { ForwardRef as ReactComponent };